import { fetchAndActivate, getValue } from "firebase/remote-config";
import { remoteConfig } from "./firebase.config";
import { updateDataLayer } from "@utils/updateDataLayer";

import { UserService } from "./api/services/userService";
import { THEME_MAP } from "./routes/onboarding/shared/hooks/useThemeParam";
import { VERSION } from "./App";
import authService, { updateApphudTracking } from "@api/services/authService";
import { apphud } from "@utils/apphud";

export const WORKFLOW = process.env.REACT_APP_WORKFLOW;

let funnelType = process.env.REACT_APP_FUNNEL;
let paywallType = process.env.REACT_APP_PAYWALL;
const remoteConfigEnabled =
  process.env.REACT_APP_REMOTE_CONFIG_ENABLED === "true";
let initialized = false;
let paywallCountdown = null;

const STORAGE_KEY = "selectedTheme";

function getQueryParams() {
  const url = new URL(window.location.href);
  const funnel = url.searchParams.get("funnel") || url.searchParams.get("f");
  const paywall = url.searchParams.get("paywall") || url.searchParams.get("p");
  const bearerToken = url.searchParams.get("bearerToken");
  const countdown =
    url.searchParams.get("paywall_countdown") || url.searchParams.get("pc");

  const t = url.searchParams.get("t");

  if (t && THEME_MAP[t]) {
    sessionStorage.setItem(STORAGE_KEY, t);
  }

  return { funnel, paywall, bearerToken, t, countdown };
}

function removeQueryParams(params) {
  const url = new URL(window.location.href);
  let changed = false;

  params.forEach((param) => {
    if (url.searchParams.has(param)) {
      url.searchParams.delete(param);
      changed = true;
    }
  });

  if (changed) {
    window.history.replaceState({}, document.title, url.pathname + url.search);
  }
}

export async function initAppConfig() {
  if (initialized) return;

  const {
    funnel: urlFunnel,
    paywall: urlPaywall,
    bearerToken,
    t,
    countdown,
  } = getQueryParams();

  if (bearerToken) {
    localStorage.setItem("token", bearerToken);
  }

  const startAuth = async () => {
    try {
      await authService.anonymousSignUp();

      const funnelType = getFunnelType();
      const paywallType = getPaywallType();

      updateDataLayer({
        event: "user_id_ev",
        user_id_val: localStorage.getItem("userId"),
      });

      await UserService.sendUserFlowData(funnelType, paywallType);
      // await updateApphudTracking(apphud.getApphudUserId());
    } catch (error) {
      window.location.replace("/");
    }
  };

  if (!localStorage.getItem("token")) {
    startAuth();
  }

  if (urlFunnel) {
    funnelType = urlFunnel;
  }

  if (urlPaywall) {
    paywallType = urlPaywall;
    updateDataLayer({ paywall_variant: urlPaywall });
  }

  if (countdown) {
    paywallCountdown = countdown;
  }

  if ((!urlFunnel || !urlPaywall) && remoteConfigEnabled) {
    try {
      await fetchAndActivate(remoteConfig);
      const funnel = JSON.parse(getValue(remoteConfig, "funnel").asString());

      const remoteFunnel = funnel.funnel_variant;
      const remotePaywall = funnel.paywall;

      if (!urlFunnel && remoteFunnel) {
        console.log("Remote funnel:", remoteFunnel);
        funnelType = remoteFunnel;
      }

      if (!urlPaywall && remotePaywall) {
        console.log("Remote paywall:", remotePaywall);
        paywallType = remotePaywall;
      }
    } catch (err) {
      console.error("Remote Config fetch failed:", err);
    }
  }

  removeQueryParams([
    "f",
    "p",
    "funnel",
    "paywall",
    "bearerToken",
    "paywall_countdown",
    "pc",
  ]);

  if (localStorage.getItem("token")) {
    try {
      await UserService.sendUserFlowData(
        funnelType,
        paywallType,
        VERSION[funnelType],
        t
      );
    } catch (error) {
      console.log("error send funnelType and paywallType");
    }
  }

  updateDataLayer({
    event: "var_ready",
    funnel_variant: funnelType,
    funnel_version: VERSION[funnelType],
    funnel_topic: THEME_MAP[t]?.themeKey || "No topic",
  });

  initialized = true;
}

export function getFunnelType() {
  if (!initialized) {
    console.warn("App config not initialized yet");
  }
  return funnelType;
}

export function getPaywallCountdown() {
  if (!initialized) {
    console.warn("App config not initialized yet");
  }
  return paywallCountdown;
}

export function getPaywallType() {
  if (!initialized) {
    console.warn("App config not initialized yet");
  }
  return paywallType;
}
